export const QR_TYPE_GOOGLE_REVIEW = "gr";